import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';
import { array } from 'yup';

const toast = useToast();
const useServicesStore = defineStore({
    id: 'services',
    state: () => ({
        eggDescList: [
            {
                eggBackgroundObj: { componentName: 'services', imgName: 'customized', imgFormat: 'png' },
                label: 'services.customized'
            },
            {
                eggBackgroundObj: { componentName: 'services', imgName: 'comprehensive', imgFormat: 'png' },
                label: 'services.comprehensive'
            },
            {
                eggBackgroundObj: { componentName: 'services', imgName: 'professional', imgFormat: 'png' },
                label: 'services.professional'
            }
        ],
        servicesDescList: [
            {
                id: 'advisory',
                label: 'services.advisory',
                description: 'services.advisoryDesc',
                image: { componentName: 'services', imgName: 'advisory', imgFormat: 'png' },
            },
            {
                id: 'checkupservices',
                label: 'services.checkupservices',
                description: 'services.checkupservicesDesc',
                image: { componentName: 'services', imgName: 'checkupServices', imgFormat: 'png' },
            },
            {
                id: 'telemedicine',
                label: 'services.telemedicine',
                description: 'services.telemedicineDesc',
                image: { componentName: 'services', imgName: 'telemedicine', imgFormat: 'png' },

            },
            {
                id: 'thirdpartyadministration',
                label: 'services.thirdPartyAdministration',
                description: 'services.thirdPartyAdministrationDesc',
                image: { componentName: 'services', imgName: 'thirdPartyAdministration', imgFormat: 'png' },
            },
            {
                id: 'outpatientservices',
                label: 'services.outpatientServices',
                description: 'services.outpatientServicesDesc',
                image: { componentName: 'services', imgName: 'outpatientServices', imgFormat: 'png' },
            },
            {
                id: 'vaccinations',
                label: 'services.vaccinations',
                description: 'services.vaccinationsDesc',
                image: { componentName: 'services', imgName: 'vaccinations', imgFormat: 'png' },
            },
            {
                id: 'emergencyservices',
                label: 'services.emergencyServices',
                description: 'services.emergencyServicesDesc',
                image: { componentName: 'services', imgName: 'emergencyServices', imgFormat: 'png' },
            },
            {
                id: 'productsprocurement',
                label: 'services.productsProcurement',
                description: 'services.productsProcurementDesc',
                image: { componentName: 'services', imgName: 'productsProcurement', imgFormat: 'png' },
            },
        ],
        whyChooseUsEggDescList: [
            {
                eggBackgroundObj: { componentName: 'services', imgName: 'checkupPackageComprehensive', imgFormat: 'png' },
                label: 'services.comprehensive'
            },
            {
                eggBackgroundObj: { componentName: 'services', imgName: 'checkupPackageCustomized', imgFormat: 'png' },
                label: 'services.customized'
            },
            {
                eggBackgroundObj: { componentName: 'services', imgName: 'checkupPackageProfessional', imgFormat: 'png' },
                label: 'services.professional'
            }
        ],
        ourHealthPackagesList: [
            {
                label: '',
                price: '',
                consultDuration: '',
                followUpDuration: '',
                attachment: '',
                packageCode: '',
            },
            // sample JSON object data
            // { 
            //     label: 'services.standard',
            //     price: '2800',
            //     consultDuration: '30',
            //     followUpDuration: '15',
            //     attachment: 'ComprehensiveScan'
            // }, {} ...
        ],
        isHoverFollowUp: false,
        isHoverConsult: false,
        curHoverTarget: null,
        isShowInvestigations: false,
        ageList: [],
        healthPackagesCodeList: [''],
        healthPackagesDetailList: [
            {},
            // *** Sample data ***
            //  basic package item : 
            // {
            //     label: 'services.neurological',
            //     includePackagesList: ["standard", "silver", "gold", "platinum"],
            //     headerGroupKey: "CAT-BASIC"
            // },
            // {
            //     label: 'services.measurements',
            //     includePackagesList: ["standard", "silver", "gold", "platinum"],
            //     headerGroupKey: "CAT-BASIC"

            // category: package item should be placed following under the related categeory obj
            // {
            //     label: 'services.investigations',
            //     isHeader: true,
            //     headerGroupKey: "CAT-INV"
            // },
            // {
            //     label: 'services.chestXRay',
            //     includePackagesList: ["standard", "silver", "gold", "platinum"],
            //     headerGroupKey: "investigations"
            // },
        ],
        allPlanInfo: [],
        allPlanItemInfo: [],
        allPlanItemMapping: [],
        allPlanItemPerPlan: [],
        allPlanGroup: [],
        allPlanCategory: {},
        showItemPerCategory: {},
        addOnList: [
            // *** Sample data ***
            // {
            //     label: 'Body Mass Index (BMIe)',
            //     itemCode: 'HPI-BMI1'
            // },
        ],

        // CAT-INV
        healthDetailToggleList: [''] //be default list will spreaded; recognize by code of category
    }),
    getters: {},
    actions: {
        async downloadPDF(attachmentName: string) {
            console.log("import.meta....: " + import.meta.env.VITE_SERVER_BASE_URl + " path: " + import.meta.env.VITE_SERVER_BASE_URl + '/healthPackage/' + attachmentName);
            const pdfUrl = new URL('/healthPackage/' + attachmentName, import.meta.env.VITE_SERVER_BASE_URl);
            console.log('open PDF file url ===> ', pdfUrl);
            window.open(pdfUrl);
        },

        async updateHealthPackagesDetailList() {
            this.healthPackagesDetailList.splice(0, this.ourHealthPackagesList.length);

            try {
                console.log('api: Health package category: ');
                const response: any = await apiClient.get('/api/scwebsite/code/HEALTH_PACKAGE_CATEGORY/fullList');
                //debugger;
                if (!response.isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                }
                const categoryList = response.data;
                for (let i = 0; i < categoryList.length; i++) {
                    var category: any = {
                        label: categoryList[i].name,
                        isHeader: categoryList[i].name != null ? true : false,
                        headerGroupKey: categoryList[i].code
                    };
                    if (category.isHeader)
                        this.healthPackagesDetailList.push(category);
                    if (category.name == null)
                        this.healthDetailToggleList.push(category.headerGroupKey);

                    const categoryDetailList: any = await apiClient.get('/api/scwebsite/getHealthPackageDetailByCategoryCode/' + category.headerGroupKey);
                    var packageItem: {
                        label: string;
                        includePackagesList: string[];
                        headerGroupKey: string;
                    } = {
                        label: '',
                        includePackagesList: [],
                        headerGroupKey: ''
                    };

                    var temp_codeReference = '';
                    for (let j = 0; j < categoryDetailList.length; j++) {
                        if (categoryDetailList[j].code != temp_codeReference) {
                            if (packageItem.includePackagesList.length > 0) {
                                this.healthPackagesDetailList.push(packageItem);
                                //clear object value
                                packageItem = {
                                    label: '',
                                    includePackagesList: [],
                                    headerGroupKey: ''
                                };
                            }
                            packageItem.label = categoryDetailList[j].name;
                            packageItem.includePackagesList.push(categoryDetailList[j].packageCode);
                            packageItem.headerGroupKey = category.headerGroupKey;
                            temp_codeReference = categoryDetailList[j].code;

                        } else if (categoryDetailList[j].code == temp_codeReference) {
                            packageItem.includePackagesList.push(categoryDetailList[j].packageCode);
                        }
                        if (j == categoryDetailList.length - 1) {
                            this.healthPackagesDetailList.push(packageItem);
                        }
                    }
                };

            } catch (err: any) {
                // toast.error(err.message);
            }
        },

        async getHealthHistory(codeType: String) {
            try {
                console.log('api: Health history: ');
                const response: any = await apiClient.get('/api/scwebsite/code/' + codeType + '/fullList');
                const isSuccess = response.isSuccess;
                //debugger;

                if (!isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                }
                return response
            } catch (err: any) {
                // toast.error(err.message);
            }
        },

        async getRecommendedPackageCode_AddOn(body: object) {
            try {
                const response: any = await apiClient.post('/api/scwebsite/getRecommendedPackageCode_AddOn', body);
                const isSuccess = response.isSuccess;
                //debugger;
                if (!isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                }
                return response.data[0];
            } catch (err: any) {
                // toast.error(err.message);
            }
        },

        async _sortOurHealthPackagesList(arr: any) {
            const n = arr.length;
            for (let i = 0; i < n - 1; i++) {
                for (let j = 0; j < n - i - 1; j++) {
                    const price1 = parseInt(arr[j].price);
                    const price2 = parseInt(arr[j + 1].price);

                    if (price1 > price2) {
                        const temp = arr[j];
                        arr[j] = arr[j + 1];
                        arr[j + 1] = temp;
                    }
                }
            }
            this.ourHealthPackagesList.forEach((item, index) => {
                this.healthPackagesCodeList[index] = item.packageCode;
            });
        },

        async updateHealthPackagesList() {
            try {
                const response: any = await apiClient.get('/api/scwebsite/getAllHealthPackageInfo');
                const isSuccess = response.isSuccess;

                //debugger;
                if (!isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                    return;
                }
                var responseDataSet_array = response.data[0];
                this.ourHealthPackagesList.length = 0;
                for (let i = 0; i < responseDataSet_array.length; i++) {
                    var responseDataSet = responseDataSet_array[i];
                    const healthPackage = {
                        label: responseDataSet.name,
                        price: responseDataSet.price,
                        consultDuration: responseDataSet.consultDuration,
                        followUpDuration: responseDataSet.followUp,
                        attachment: responseDataSet.attachment,
                        packageCode: responseDataSet.code
                    };
                    this.ourHealthPackagesList[i] = healthPackage;
                }
                this._sortOurHealthPackagesList(this.ourHealthPackagesList);
                // console.log('@@@', this.ourHealthPackagesList);
            } catch (err: any) {
                // toast.error(err.message);
            }
        },

        async getAllPlanInfo() {
            try {
                const response: any = await apiClient.post('/api/scwebsite/getAllPlanInfo');

                //debugger;
                if (response.statusCode != 1) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                    return;
                }

                this.allPlanInfo = response.plans;
                this.allPlanItemInfo = response.items;
                this.allPlanItemPerPlan = response.itemPerPlan;
                this.allPlanGroup = response.choiceGroups;
                this.allPlanCategory = response.categories;
                
                for (const index in this.allPlanCategory) {
                    if (index == "BASIC")
                        this.showItemPerCategory[index] = true;
                    else 
                        this.showItemPerCategory[index] = false;
                }

                console.log(JSON.stringify(this.showItemPerCategory));
            } catch (err: any) {

            }
        },

        async updateAddOnList (arr: any){
            this.addOnList.splice(0, this.addOnList.length);
            arr.forEach( (element:any) =>{
                const obj = {
                    label: element.packageItemName,
                    itemCode: element.packageItemCode
                }
                this.addOnList.push(obj);
            });
        }
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useServicesStore, import.meta.hot));
}

export { useServicesStore };
